'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createWalker;

var _defs = require('./defs');

var IGNORED_NODES = {
  SCRIPT: true,
  STYLE: true
};

function createWalker(root) {
  return document.createTreeWalker(root, NodeFilter.SHOW_TEXT, function (node) {
    return node.parentNode.className === _defs.POPUP_CLASS ? NodeFilter.FILTER_SKIP : node.parentNode.nodeName in IGNORED_NODES ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, false);
}